module.exports = __webpack_public_path__ + "static/media/home-bgi.865d1077.png";